import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { setGoogleReviewAutoReplySettingsQueryData } from './useGetGoogleReviewAutoReplySettings';

export const usePutGoogleReviewAutoReplySettings = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (settings: Api.IGoogleReviewAutoReplySettings, submitted: Api.IGoogleReviewAutoReplySettings) => void;
}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (settings: Api.IGoogleReviewAutoReplySettings) => {
			return userSession.webServiceHelper.callAsync<Api.IGoogleReviewAutoReplySettings>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'googleBusiness/reviewAutoReplySettings',
				}),
				'PUT',
				settings
			);
		},
		onError,
		onSuccess: (settings, submitted) => {
			// Write the saved settings into the cache directly so consumers that clear their pending
			// edits on success never fall back to the stale pre-save value while a refetch is in flight.
			setGoogleReviewAutoReplySettingsQueryData(settings, { impersonationContext });
			onSuccess?.(settings, submitted);
		},
	});
};
